// baseTime為moment物件
// 傳入範圍月數(range)，回傳baseTime之月份+-range共2 * range + 1 月的時間區間

export default function (baseTime, range) {
  // 這邊要注意moment的方法有些是改變原物件，有些是傳回新物件
  // 例如set(), add()方法是直接改變原物件，參照到同一個物件的變數內容都會變
  // 而.format()方法傳回的是文字

  // 將現在時間設定為當月1號12:00
  let baseTimeObj = baseTime.set({ date: 1, hours: 0, minute: 0 }),
    // 往前推range個月
    from_time = baseTimeObj.add(-range, 'M').format('YYYY-MM-DD hh:mm'),
    // 再往後推range * 2個月，就會是前rnage個月至後range個月共2 *range + 1個月區間
    // 此處實際上參數是後推range * 2 + 1個月，然後用date(0)
    // 這是將日期變為上個月的最後一天的moment小技巧
    to_time = baseTimeObj.set({ hours: 23, minute: 59 }).add(range * 2 + 1, 'M').date(0).format('YYYY-MM-DD hh:mm');

  return { from_time, to_time };
}


// WEBPACK FOOTER //
// ./src/commonJS/periodGenerator.js